import {
  hideLoading,
  showAlert,
  showLoading,
} from "../Actions/GeneralActions";
import Axios from "axios";
import Apis from "../../config/APIs";
import { getHeaders } from "../../utills";
import { getDashboardData, getUserDetails } from "../Actions/DashboardActions";

export const DashboardMiddleware = {

  onGetDashboardData: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const query = new URLSearchParams();
          query.append('limit', params.limit);
          query.append('page', params.page);

          const data = await Axios.get(Apis.dashbaord(query.toString()), await getHeaders());

          if (data?.status == 200) {
            resolve(true);
            dispatch(getDashboardData(data?.data?.data));
          }
        } catch (error) {
          console.log("errr", error?.response?.data?.message);

          reject(error);
          dispatch(
            showAlert({
              title: "dashbaord",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  onGetUserDetails: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const query = new URLSearchParams();
          query.append('id', params.id);
          query.append('limit', params.limit);
          query.append('page', params.page);
          const data = await Axios.get(Apis.user_details(query.toString()), await getHeaders());

          if (data?.status == 200) {
            resolve(true);
            dispatch(getUserDetails(data?.data?.data));
          }
        } catch (error) {
          console.log("errr", error?.response?.data?.message);

          reject(error);
          dispatch(
            showAlert({
              title: "user details",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },




};
